/* eslint-disable react-hooks/exhaustive-deps */
import _, {isArray} from 'lodash';
import moment from 'moment';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router';
import {toast} from 'react-toastify';
import ConsultBGImage from '../../assets/img/new-design/consult-bg-img.png';
import {createOrUpdateOpportunities, getMyLeads} from '../../store/actions/lead.action';
import * as types from '../../store/actions/types';
import {RootState} from '../../store/reducers';
import errorMessages from '../../utils/errorMessages';
import {buyNewDomain, capitalizeFirstLetter, checkIsUserPaid, getStatus, getUserFistName, handleDomainName, handlePageLoader, handleToast, isUserLoggedIn, isUserRole, isValidDomainName, removeLocalStorageItems} from '../../utils/handler';
import {domainType} from '../../utils/types';
import {BOXConsultantDetails, LoadingPage, NumberInput, SawHelpsContent} from '../components/CommonPages';

interface FilterOptionsType {
  status: string;
}
const filterOptions = {
  all: 'ALL',
  inProgress: 'In Progress',
  completed: 'SOLD',
};
const statusFilter: FilterOptionsType[] = [
  {
    status: filterOptions.all,
  },
  {
    status: filterOptions.inProgress,
  },
  {
    status: filterOptions.completed,
  },
];
export const UserDashboard: React.FC = (): JSX.Element => {
  const {t} = useTranslation();
  const {myLeadList, newDomainName, newOfferAmount} = useSelector((state: RootState) => state.leadReducer);
  const {pageLoading} = useSelector((state: RootState) => state.mainReducer);

  const {myProfile} = useSelector((state: RootState) => state.userReducer);
  const [activeFilter, setActiveFilter] = useState(filterOptions.all);
  const [domainList, setDomainList] = useState<domainType[]>([]);
  const [alternateDomain, addAlternateDomain] = useState(false);
  const [alterDomains, setAlterDomains] = useState<any>([]);
  const [opportunitiesList, setOpportunitiesList] = useState<any>([]);
  // const [iAgree, setIAgree] = useState(false)
  const [isAgentPaid, setIsAgentPaid] = useState(false);
  const [domainName, setDomainName] = useState('');
  const [offerAmount, setOfferAmount] = useState('');
  const [isFormSubmitted, setFormSubmitted] = useState(false);

  // const [downloadingCertificate, setDownloadingCertificate] = useState(false);
  let history = useHistory();
  const dispatch = useDispatch();
  // useEffect(() => {
  //   blockInvestor()
  // }, [])

  useEffect(() => {
    updateLeadDetail();
    if (isUserLoggedIn()) getMyLeads();
  }, [myProfile]);
  useEffect(() => {
    updateLeadDetail();
  }, [myLeadList]);

  const getAgentInfo = (index: number = 0) => {
    let lead = domainList && domainList[index];
    if (lead && lead.consultant) return lead.consultant;
    return null;
  };
  const updateLeadDetail = async () => {
    if (myLeadList?.length > 0) {
      let lead = myLeadList[0];
      if (lead) {
        let opportunities = [lead];
        setIsAgentPaid(checkIsUserPaid(lead.payments) ? true : false);

        if (lead.opportunities && isArray(lead.opportunities)) {
          // opportunities = _.filter(lead.opportunities, (opp) => opp.domainName !== lead.domainName);
          // opportunities = [...opportunities, ..._.clone(LeadOpportunity)];
          opportunities = lead.opportunities
          // console.log(opportunities, lead.opportunities, "DDDDDDDDDDDDDDDDDd")
        } else {
          // setAlternateDomain([]);
        }
        // if (!_.find(opportunities, {domainName: lead.domainName})) {
        //   opportunities.unshift(lead);
        //   console.log(opportunities, "DDDDDDDDDDDDDDDDDd")
        // }
        if (newDomainName && checkIsUserPaid(lead.payments)) {
          removeLocalStorageItems();
          let opportunitiesExist = _.find(opportunities, {domainName: handleDomainName(newDomainName)});
          if (!opportunitiesExist) {
            if (opportunities.length <= 4) {
              setAlternateDomain([], true);
              addAlternateDomain(true);
              handleToast({message: `You are an existing user, Please add ${newDomainName} as an alternate domain.`}, 'success');
            } else {
              handleToast({message: errorMessages.alternateDomainLimit}, 'success');
            }
          }
        }
        setAlternateDomain(opportunities, true);
        // setIAgree(false)
        opportunities.forEach(function (opp, i) {
          if (opp.domainName === lead.domainName) {
            opportunities.splice(i, 1);
            opportunities.unshift(opp);
          }
        });
        setOpportunitiesList([...opportunities]);
      }
      setDomainList(myLeadList);
    }
  };
  const setAlternateDomain = (opportunities: any, hasNewDomainName?: boolean) => {
    let alternateDomainList: {domainName: string; offerAmount: string; interestIn?: string}[] = [];
    _.range(0, 5).forEach((index: number) => {
      if (opportunities && isArray(opportunities)) {
        let isExist = opportunities[index];
        if (!isExist || (isExist && !isExist.domainName)) {
          let obj = {
            domainName: '',
            offerAmount: '',
          };
          alternateDomainList.push(obj);
        }
      }
    });
    if (alternateDomainList.length > 0 && newDomainName && hasNewDomainName) {
      alternateDomainList[0].domainName = newDomainName;
      alternateDomainList[0].offerAmount = newOfferAmount;
      // let interestIn = localStorage.getItem("interestIn")
      // alternateDomainList[0].interestIn = interestIn ||userInterested.buy
    }
    setAlterDomains(alternateDomainList);
  };

  // const sendAppraisalToMail = (domain: string = domainName) => {
  //   if (isUserLoggedIn()) {
  //     if (CheckAccess('EmailAppraisalCertificate')) {
  //       setDownloadingCertificate(true);
  //       sendAppraisalCertificate({domainName: domain, email: myProfile.email}).then((emailResponse) => {
  //         if (emailResponse) {
  //           handleToast({message: successMessages.appraisalSent}, 'success');
  //         }
  //         setDownloadingCertificate(false);
  //       });
  //     } else {
  //       handleToast({message: errorMessages.notAllowed});
  //     }
  //   } else {
  //     dispatch({type: types.PREVIOUS_ACTION, payload: 'sendAppraisalToMail'});
  //     dispatch({type: types.SHOW_LOGIN_WINDOW, payload: true});
  //   }
  // };
  const checkFormValid = () => {
    let isValid = true
    if (!isValidDomainName(domainName)) {
      isValid = false
    } else if (!offerAmount) {
      isValid = false
    }
    return isValid
  }
  const createLead = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true)
    if (checkFormValid()) {
      buyNewDomain(domainName, offerAmount);
    }
    // let state = {domainName};
    // if (state && isValidDomainName(domainName)) {
    //   if (domainName) {
    //     buyNewDomain(domainName);
    //   } else {
    //     handleToast({message: errorMessages.continueServiceWithDomainName});
    //   }
    // } else {
    //   handleToast({message: errorMessages.domainWithoutExtension});
    // }
  };
  const loadLead = () => {
    if (isUserRole()) {
      let lead = domainList && domainList[0];
      if (lead.consultant) {
        dispatch({type: types.LEAD_ASSIGNED_AGENT, payload: lead.consultant});
      }
      dispatch({type: types.LEAD_DETAILS, payload: lead});
      if (checkIsUserPaid(lead.payments)) {
        history.push('/agent-details-questions');
      } else {
        history.push('/hire-consultant');
      }
    }
  };

  return pageLoading ? (
    <LoadingPage />
  ) : (
    <div className="">
      <div className={'ash-bg  pt-2 pb-50'}>
        <img alt="" className="consultant-bg-img" src={ConsultBGImage}></img>
        <div className="container d-flex justify-content-center  flex-column">
          <div className="container">
            <div className="text-center position-relative">
              {domainList.length === 0 ? (
                <>
                  {/* <div className="title mb-1 ">Welcome to Saw, {getUserFistName()}!</div>
                  <p>Please give us an opportunity to help you to buy a domain</p> */}
                  <div className="row m-0 text-left mt-5">
                    <div className="col-lg-7 col-md-12 pl-2">
                      <span className="sub-title ">Don’t Get Left Behind. Acquire The Best Domain With Saw.com, <span className=''>{getUserFistName()}</span></span>
                      <div className="saw-content-desktop">
                        <SawHelpsContent />
                      </div>
                    </div>
                    <div className="col-lg-5 col-md-12 ">
                      <div className='card'>
                        <form className={"col-12 card-body " + (isFormSubmitted ? "was-validated" : "")} noValidate onSubmit={createLead}>
                          <div className=" form-group ">
                            <input autoFocus placeholder={t('domainName', {domainName: myProfile.name})} autoComplete="off" type="text" name="domainName" value={domainName} onChange={(e) => setDomainName(e.target.value)}
                              className={'custom-input form-control saw-input ' + (isFormSubmitted && domainName === '' ? 'is-invalid' : '')} required />
                            <div className="invalid-feedback">{t('Please Enter Domain name')}</div>
                          </div>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <div className="input-group-text btn-group-input" id="btnGroupAddon">
                                $
                              </div>
                            </div>
                            <NumberInput placeholder="Budget *" value={offerAmount} name="offerAmount" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOfferAmount(e.target.value)} required />
                            <div className="invalid-feedback">{t('Please Enter Budget')}</div>
                          </div>
                          <div className='d-flex justify-content-center mt-4'>
                            <button type="submit" className=" btn-grad btn normal-btn pl-4 pr-4" data-action="appraisal-search" onSubmit={createLead}>
                              {t('get started')}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </>
              ) : !isAgentPaid ? (
                <>
                  <div className="title">Dashboard Locked 🔒</div>
                  <div className="">Thanks for setting up your Saw.com account {myProfile.name ? capitalizeFirstLetter(myProfile.name.split(' ')[0]) : ''} - we’re looking forward to helping you acquire your next domain. Unfortunately, you can’t access your dashboard or contact your dedicated broker until you’ve completed the checkout process.</div>
                  <div className="row justify-content-center mt-3">
                    <button onClick={() => loadLead()} type="button" className={'btn btn-grad'}>
                      COMPLETE CHECKOUT
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="title mb-1 ">I’m working on your domain, {getUserFistName()}!</div>
                  <p>You can add up to four alternatives to get a clearer picture…</p>
                  {opportunitiesList.length < 5 && !alternateDomain && (
                    <div className="row justify-content-center">
                      <button type="button" className="btn btn-grad " onClick={() => addAlternateDomain(!alternateDomain)}>
                        <span>{t('Add ALTERNATIVE Domains')}</span>
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {isArray(domainList) && domainList.length > 0 ? (
        <div className="container mt-4">
          <div className="d-lg-flex">
            <div className="agent-card mx-auto">{getAgentInfo(0) && BOXConsultantDetails(getAgentInfo(0), true, isAgentPaid)}</div>
            <div className=" col-lg-8 col-md-12 mt-5 pl-3">
              {alternateDomain && <AlternateDomainsView getMyLeads={() => getMyLeads()} alterDomains={alterDomains} addAlternateDomain={addAlternateDomain} />}
              <div className="sub-title">Here are your domains…</div>
              <div>
                <div className="btn-group button-filter" role="group" aria-label="Basic example">
                  {statusFilter.map((filter: FilterOptionsType, index: number) => (
                    <button key={index} onClick={() => setActiveFilter(filter.status)} type="button" className={'btn ' + (activeFilter === filter.status ? ' btn-primary' : ' btn-outline-primary  ')}>
                      {filter.status === filterOptions.completed ? 'Completed' : filter.status}
                    </button>
                  ))}
                </div>
                <div className="mt-3">
                  {opportunitiesList.map(
                    (domain: domainType, index: number) =>
                      domain.status === (activeFilter === filterOptions.all ? domain.status : isAgentPaid ? activeFilter : '') && (
                        <div
                          key={index}
                          className={'  dashboard-cards ' + (index === 0 ? ' c-pointer main-domain ' + (!isAgentPaid ? ' ' : '') : '')}
                          onClick={() => {
                            index === 0 && loadLead();
                          }}
                        >
                          {/* {!isAgentPaid && <div className="hire-agent-highlight">Click here to complete the checkout and get started.</div>} */}
                          <div className="d-flex justify-content-between f-bold fs-18">
                            <span className="fs-25 theme-color underline">{domain.domainName}</span>
                            <span>
                              <span className={'text-uppercase  mt-1  f-bold ' + getStatus(isAgentPaid ? domain.status : 'pending').color}>
                                <i className={getStatus(isAgentPaid ? domain.status : 'pending').icon}></i>
                                <span className="ml-2">{getStatus(isAgentPaid ? domain.status : 'pending').status}</span>
                              </span>
                              {!isAgentPaid && <i className="fas fa-question-circle ml-2 text-warning" title="Click here to hire agent"></i>}
                            </span>
                          </div>
                          <div className="f-dull row mt-3">
                            <div className="col-6 col-md-5">Offered Price (USD)</div>
                            <div className="col-6 col-md-5">Start / End Date</div>
                          </div>
                          {isAgentPaid ? (
                            <div className={'row f-bold '}>
                              <div className="col-6 col-md-5">{domain.offerAmount || '    ----'}</div>
                              <div className="col-6 col-md-5">
                                {moment(domain.createdAt).format('ll')} / {domain.soldDate ? moment(domain.soldDate).format('ll') : '-----'}
                              </div>
                            </div>
                          ) : (
                            <div className={'row f-bold blur-text'}>
                              <div className="col-6 col-md-5">{'XXXXXX'}</div>
                              <div className="col-6 col-md-5">XXXXXXXXXXX</div>
                            </div>
                          )}
                          {/* {domain.status === 'sold' && (
                            <div className="row justify-content-end ">
                              <button className="btn-primary primary-dark btn btn-normal bb-btn" onClick={() => sendAppraisalToMail(domain.domainName)} disabled={downloadingCertificate}>
                                {downloadingCertificate ? <i className="fa-solid fa-spinner fa-spin-pulse"></i> : <i className="fa-solid fa-file-pdf "></i>}
                                <span className="ml-2">Domain Appraisal Certificate</span>
                              </button>
                              <button
                                className="btn btn-grad "
                                onClick={() => {
                                  index === 0 && loadLead();
                                }}
                              >
                                <span>{t('More Info')}</span>
                              </button>
                              <button className="btn btn-grad ">
                                <span>{t('Buy This Domain')}</span>
                              </button>
                            </div>
                          )} */}
                        </div>
                      ),
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        null
      )}
    </div>
  );
};

export default UserDashboard;

export const AlternateDomainsView = (props: any) => {
  const {t} = useTranslation();
  const {myLeadList} = useSelector((state: RootState) => state.leadReducer);
  const [domainList] = useState<domainType[]>(myLeadList);
  const [loaderBtn, setLoaderBtn] = useState(false);
  const [alternateDomains, setAlternateDomains] = useState<any>([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [iAgree, setIAgree] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.alterDomains && Array.isArray(props.alterDomains)) setAlternateDomains(JSON.parse(JSON.stringify(props.alterDomains)));
  }, []);
  const getAgentInfo = (index: number = 0) => {
    let lead = domainList && domainList[index];
    if (lead && lead.consultant) return lead.consultant;
    return null;
  };

  const submitAlternativeDomains = async (e?: React.FormEvent) => {
    e && e.preventDefault();
    setFormSubmitted(true);

    if (iAgree && checkValidation()) {
      handlePageLoader(true)
      let lead = domainList[0];
      if (lead) {
        let payload = {
          leadUID: lead.UID,
          opportunity: alternateDomains,
        };
        setLoaderBtn(true);

        let res = await createOrUpdateOpportunities(payload);
        localStorage.removeItem('interestIn');
        if (res) {
          dispatch({type: types.SET_DOMAIN_NAME, payload: ''});
          dispatch({type: types.SET_DOMAIN_OFFER_AMOUNT, payload: ''});
          props.getMyLeads();
          setIAgree(false);
          props.addAlternateDomain(false);
          toast.success(t(res.data));
        }
        setFormSubmitted(false);
        setLoaderBtn(false);
        handlePageLoader(false)
      }
    }
  };
  const checkValidation = () => {
    let isValid = false;
    alternateDomains.forEach((element: {domainName: string; offer: string; UID: string}) => {
      if (element.domainName) {
        isValid = true;
      }

      // if (element.domainName === "" && element.offer) {
      //     // yet to complete this action
      // }
      if (element.UID) {
        isValid = true;
      }
    });
    if (!isValid) {
      setErrorMessage(t('Please enter any one domain'));
    } else {
      setErrorMessage('');
    }
    return isValid;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let name = e.target.name;
    let value = e.target.value;
    let payload: any = alternateDomains[index];
    payload[name] = value;
    setAlternateDomains([...alternateDomains]);
  };

  return (
    <div className={'pt-3'}>
      {/* <div className="row justify-content-center">
        <span className="text-danger fs-13">{errorMessages.unSupportedExtensionShortMsg}</span>
      </div> */}
      {alternateDomains.map((domain: domainType, i: number) => (
        <div className="row" key={i}>
          <div className="col-8">
            <label className="mt-2 fw-600">{t('Domain Name')} </label>
            <input autoFocus={i === 0 ? true : false} autoComplete="off" type="text" className="form-control saw-input no-valid" name="domainName" value={domain.domainName} onChange={(e) => handleChange(e, i)} />
          </div>
          <div className="col-4">
            <label className="mt-2 fw-600">{t('Budget')}</label>
            <NumberInput placeholder="$" value={domain.offerAmount} name="offerAmount" onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, i)} />

            {/* <input
              autoComplete="off"
              placeholder="$"
              // disabled={domain.domainName === ""}
              onKeyDown={(e) => {
                [189, 69, 109, 187, 107].includes(e.keyCode) && e.preventDefault();
              }}
              min={0}
              type="number"
              className=
              name="offerAmount"
              value={domain.offerAmount}
              onChange={(e) => handleChange(e, i)}
            /> */}
          </div>
          <hr className="styled-hr" />
        </div>
      ))}
      <form onSubmit={submitAlternativeDomains} className={formSubmitted ? ' was-validated ' : ''} noValidate>
        <div className="pt-3">
          <div className="mb-2">
            <p>{getAgentInfo()?.name}, your domain consultant, will be happy to follow up on these domains and give you some information about their registrant, value and timeline for acquisition. They fall under the same terms as the initial domain you inquired on.</p>
            {/* <Trans >
                        {t("These domains fall")}
                        <span className="theme-color  hover-u" onClick={() => dispatch({ type: types.TERMS_AND_SERVICE, payload: true })}></span>
                    </Trans> */}
          </div>
          {errorMessage && (
            <div className="row justify-content-center text-danger">
              {' '}
              <span>{errorMessage}</span>
            </div>
          )}
          <div className="form-check-label mt-3 d-flex fs-14 col-12">
            <input type="checkbox" name="iAgree" checked={iAgree} onChange={() => setIAgree(!iAgree)} className="form-check-input saw-check-box" id="adventure_id" required />
            <div className="">
              I have read and accept the{' '}
              {/* <span className="theme-color">
                Privacy Policy <span className="text-dark"> & </span> Terms of Service
              </span> */}
              {/* <span className="theme-color hover-u" onClick={() => dispatch({type: types.TERMS_AND_SERVICE, payload: true})}> */}
              <a className="theme-color hover-u" href="https://saw.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>{' '}
              and{' '}
              <a className="theme-color hover-u" href="https://saw.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>{' '}
            </div>
          </div>
          {!iAgree && formSubmitted && <div className="row justify-content-center text-danger">{t('Please agree terms')}</div>}

          <div className="row justify-content-center mt-2">
            <button type="submit" className="btn btn-grad" disabled={loaderBtn} onClick={submitAlternativeDomains}>
              {loaderBtn ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : t('Submit')}
            </button>
            <button
              type="button"
              className="btn btn-outline-warning  "
              onClick={() => {
                props.addAlternateDomain(false);
                setFormSubmitted(false);
              }}
            >
              {t('Close')}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
